import React from 'react'
import '../css/hero.scss'
import Ruta from './Ruta'


export default function Hero ({ route,
    setRoute,
    section,
    setSection
}) {

  return (
    <section className='hero'>
        <div className='container'>
            <div className='hero_content'>
                {/* Pasamos la función para cambiar la sección */}
                <Ruta
                    route={route}
                    onChangeRoute={setRoute}
                    activeSection={section}
                    onChangeSection={setSection} />

            </div>
           
        </div>
    </section>
  )
}
